import React, { useRef, useState } from "react";

import CopyObjectIcon from "../Buttons/CopyObjectIcon";

function CopyTablesObject({ tableRef }) {
  const [isCopied, setIsCopied] = useState(false);
  const [text, setText] = useState("Copy table to clipboard");

  const handleCopyClick = async () => {
    const tableNode = tableRef.current;
    if (!tableNode) return;

    try {
      // Build HTML and plain text by reading textContent from each cell
      // This avoids issues with fixed layout / overflow hidden truncating copied text
      const rows = tableNode.querySelectorAll("tr");
      let html = '<table style="border-collapse: collapse; font-family: Arial, sans-serif;">';
      const plainRows = [];

      rows.forEach((row) => {
        html += "<tr>";
        const plainCells = [];
        const cells = row.querySelectorAll("th, td");

        cells.forEach((cell) => {
          const tag = cell.tagName.toLowerCase();
          const colspan = cell.getAttribute("colspan");
          const rowspan = cell.getAttribute("rowspan");
          const bg = cell.style.backgroundColor || (tag === "th" ? "#4472c4" : "#ffffff");
          const color = cell.style.color || (tag === "th" ? "#ffffff" : "#000000");
          const align = cell.style.textAlign || "left";
          const fontWeight = cell.style.fontWeight || (tag === "th" ? "600" : "normal");

          let attrs = `style="background-color: ${bg}; color: ${color}; text-align: ${align}; font-weight: ${fontWeight}; padding: 4px 8px; border: 1px solid #e0e0e0; white-space: nowrap;"`;
          if (colspan) attrs += ` colspan="${colspan}"`;
          if (rowspan) attrs += ` rowspan="${rowspan}"`;

          // Use textContent to get full text regardless of overflow/truncation
          const cellText = cell.textContent.trim();
          html += `<${tag} ${attrs}>${cellText}</${tag}>`;

          // For plain text, expand colspan
          const span = parseInt(colspan) || 1;
          plainCells.push(cellText);
          for (let i = 1; i < span; i++) {
            plainCells.push("");
          }
        });

        html += "</tr>";
        plainRows.push(plainCells.join("\t"));
      });

      html += "</table>";
      const plainText = plainRows.join("\n");

      // Use Clipboard API with both HTML and plain text
      // eslint-disable-next-line no-undef
      if (typeof ClipboardItem !== "undefined" && navigator.clipboard && navigator.clipboard.write) {
        const htmlBlob = new Blob([html], { type: "text/html" });
        const textBlob = new Blob([plainText], { type: "text/plain" });
        // eslint-disable-next-line no-undef
        const clipboardItem = new ClipboardItem({
          "text/html": htmlBlob,
          "text/plain": textBlob,
        });
        await navigator.clipboard.write([clipboardItem]);
      } else {
        // Fallback to plain text
        await navigator.clipboard.writeText(plainText);
      }
    } catch (err) {
      console.error("Failed to copy table:", err);
      // Final fallback: use the old execCommand approach
      try {
        const range = document.createRange();
        range.selectNode(tableNode);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
      } catch (fallbackErr) {
        console.error("Fallback copy also failed:", fallbackErr);
      }
    }

    setIsCopied(true);
    setText("Table copied");
    setTimeout(() => {
      setIsCopied(false);
      setText("Copy table to clipboard");
    }, 3000);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <button
        onClick={handleCopyClick}
        style={{ border: "none", background: "transparent", cursor: "pointer" }}
      >
        <CopyObjectIcon text={text} />
      </button>
    </div>
  );
}

export default CopyTablesObject;
